import { createAdvancedOrderProduct, contactFormTemplate } from '../global'
import { initSwiperGallery } from './gallery'
import { scrollToElement, isMobile, createSwiperProductBlocks } from '../base'
import { initProductVariants } from "./product-variants";

function moveAddDetailElements() {
    $('.p-code').insertBefore('.p-detail-inner-header');
    $('<div class = availability-wrapper>').insertBefore('.p-to-cart-block')
    $('.p-data-wrapper .availability-wrapper').append($('.detail-parameters td:has(.availability-label)'))
    $('<div class = cart-inner-wrapper>').insertBefore('.p-to-cart-block')

    $('.cart-inner-wrapper').append(
        $('.p-final-price-wrapper'),
        $('.availability-wrapper'),
    )

    const product = $('.p-image-wrapper');
    const discountRaw = product.find('.price-save').text().trim();
    const discount = discountRaw.replace(/[()]/g, '').trim();
    const flagAction = product.find('.flag-action');

    if (discount && flagAction.length) {
        flagAction.text(discount);
    }

    // Scroll to description
    $('.scroll-to-description').on('click', handleScrollToDescription)

    // Text nad názvem produktu - může se přidat hodnocení produktu, kód produktu, značka apod.
    upperTitleText()
}

function upperTitleText() {
    if (isMobile()) {
        $('.p-detail-inner-header-mobile .h1').after(`<div class = "upper-title-text"></div>`)
    } else {
        $('.p-detail-inner-header').before(`<div class = "upper-title-text"></div>`)
    }
}

function addImageAndPriceToAdvancedOrderDetail() {
    const image = $('.p-image img').attr('src')
    const price = $('.price-final-holder:not(.no-display)').text()
    const name = getShoptetDataLayer('product').name

    createAdvancedOrderProduct({ image, price, name })
}

function handleScrollToDescription() {
    const scrollLocation = $('#tab-content').length ? $('#tab-content') : $('.accordion-content')
    scrollToElement(scrollLocation)

    const firstTab = $('.custom-tab-link').first()
    const nextSibling = firstTab.next()

    setTimeout(() => {
        firstTab.addClass('open')
        setTimeout(() => nextSibling.addClass('active'), 200)
        setTimeout(() => nextSibling.removeClass('fade'), 230)
    }, 350)
}

function addContactForm() {
    // Add contact form
    $(contactFormTemplate({ productForm: true })).insertAfter('.p-detail-tabs-wrapper')
}

function detailTextChanges() {}

export function initDetail() {
    // Add detail elements
    moveAddDetailElements()
    detailTextChanges()
    // addContactForm()

    // Gallery
    initSwiperGallery()

    // Products slider
    createSwiperProductBlocks()

    // mezikošík
    addImageAndPriceToAdvancedOrderDetail()

    initProductVariants()

    document.addEventListener('ShoptetSplitVariantParameterChange', () => {
        setTimeout(() => {
            addImageAndPriceToAdvancedOrderDetail()
        }, 100)
    })
}
